import React, { useState } from 'react'
import { ChromePicker } from 'react-color'

const ColorPicker = ({ value, onChange, position = 'right-0' }) => {
  const [openPicker, setOpenPicker] = useState(false)

  const styles = {
    cover: {
      position: 'fixed',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
    },
  }

  const handleClick = () => {
    setOpenPicker((openPicker) => !openPicker)
  }

  const handleClose = () => {
    setOpenPicker(false)
  }

  const handleChange = (color) => {
    onChange(color.hex)
  }

  return (
    <div>
      <div onClick={handleClick} className="flex align-items-center ">
        <span className="mx-3">{value}</span>
        <div
          style={{ background: value, width: '24px', height: '24px' }}
          className="rounded-full cursor-pointer"
        />
      </div>
      {openPicker ? (
        <div className={`absolute ${position} my-1 z-10`}>
          <div style={styles.cover} onClick={handleClose} />
          <ChromePicker color={value} onChange={handleChange} disableAlpha={true} />
        </div>
      ) : null}
    </div>
  )
}

export default ColorPicker
